<template>
  <div class="flexEvent">
    <Ecoin :EcoinObj="EcoinObj" @onChange="upDataList"/>
    <EcoinList ref="dateTime" :loading="loading" :upDataListNumber="upDataListNumber" @on-change="upDataList" @onChange="simpleInfo"/>
    <div class="page">
      <Page :total="total" :current="1" :page-size="pageSize" @on-change="pageChange"></Page>
    </div>
  </div>
</template>

<script>
import Ecoin from './Ecoin/Ecoin.vue';
import EcoinList from './EcoinList/EcoinList.vue';
import { getCompanyIdInSession } from '@/libs/util';
export default {
  name: 'EcoinAccount',
  components: {
    Ecoin: Ecoin,
    EcoinList: EcoinList
  },
  data () {
    return {
      upDataListNumber: [],
      total: null,
      pageSize: null,
      current: 1,
      loading: false,
      EcoinObj: {}
    }
  },
  mounted () {
    this.upDataList();
  },
  methods: {
    upDataList () {
      this.$get(`/customer/getRechargeTotal`).then(res => {
        if (res.success) {
          this.EcoinObj = res.data
          console.log(this.EcoinObj)
        }
      })
      let orderListObj = {
        'memberId': getCompanyIdInSession(),
        'page': this.current,
        'rows': 5,
        'type': '0'
      };
      this.loading = true;
      this.$get(`/customer/rechargeApplyList`, orderListObj).then((res) => {
        if (res.success) {
          this.upDataListNumber = res.data.list;
          this.loading = false;
          this.total = res.data.total;
          this.pageSize = res.data.pageSize;
          this.current = res.data.pageNum;
        } else {
          this.loading = false;
        }
      })
    },
    pageChange (e) {
      console.log(e);
      this.current = e;
      this.upDataList();
    },
    simpleInfo () {
      this.$get(`/customer/simple/info`).then((res) => {
        this.EcoinObj = res.data;
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .flexEvent{
    width: 100%;
    padding: 20px;
    .page{
      margin-top: 50px;
      .ivu-page{
        text-align: center;
      }
    }
  }
</style>
